import { Autocomplete, TextField } from '@mui/material';
import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback, useEffect, useState } from 'react';

export const PriceResList = ({ progId }) => {

  const rsrc = useRsrc();
  const [prods, setProds] = useState(null);
  const [prod, setProd] = useState(null);

  useEffect(() => {
    const rowsReq = {
      replaceParams: {
        progId: progId
      }
    }
    rsrc.rows('md', 'PROG_PRODS', rowsReq).then(res => {
      setProds(res);
      setProd(res[0]);
    });
  }, []);

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.and(ExprUtils.whereParams('prodId', prod.id),
      ExprUtils.whereParams('progId', progId)));
  }, [prod?.id]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
    tabButtons.push(
      <Autocomplete
        disablePortal
        disableClearable
        options={prods}
        getOptionLabel={(option) => option.code + ' (' + option.name + ')'}
        sx={{ width: 300 }}
        value={prod}
        onChange={(_, newProd) => {
          setProd(newProd);
        }}
        renderInput={(params) => <TextField {...params} label="Product" />}
      />
    );
  }

  if (!prod) return <></>;

  return (
    <EntityList entity="PRICE_RES" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />
  )
}